const content = {
  component: 'PageTypeA',
  cssClass: 'page-two-b',
  meta: {
    title: 'Cancer-Fighting Mustachioed Warriors raise their tech swords',
    description: `CERN is producing increasing amounts of data—and they need an effective solution to store it.`,
    og: {
      type: 'website',
      title: 'Transforming charity with tech — Read more',
      description: `Charities are using the cloud to automate digital communications to increase engagement with fundraisers.`,
		image: require('../../assets/images/social/og_page2-B.jpg')
    },
    twitter: {
      card: 'summary',
      title: 'Discover how charities are using the cloud to reach more fundraisers',
      description: `Men's health charity Movember Foundation turns to the cloud to automate digital communications, transforming how it engages with fundraisers.`,
      site: '@Oracle',
      creator: '@Oracle',
      image: require('../../assets/images/social/twitter_page2-B.jpg')
    }
  },
  title: 'Cancer-Fighting Mustachioed Warriors raise their tech swords',
  heroImage: {
	preload: require('../../assets/images/backgrounds/p2b/page-two_b-pre.jpg'),
    loaded: require('../../assets/images/backgrounds/p2b/page-two_b@2x.jpg')
  },
  sections: [
    { 
      component: 'SectionQuote', 
      content: {
        quote: `We’re using technology to connect with a lot more of our fundraisers in a more efficient way.`,
        author: `Meaghan Billinski`,
        position: `Marketing Automation Director, Movember Foundation`,
        type: 'quote',
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
		For nearly 15 years, Australia’s Movember Foundation has been raising money for research on diseases that strike men, particularly testicular and prostate cancer.  As it undertakes its peak autumn fundraising drive, the charity is using Web-based software to let donors make recurring gifts and encourage more companies to participate in fundraising events.
        `,
        type: 'intro'
      }
    },
    { 
      component: 'SectionSeperator', 
      content: {
        image: null
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>Born out of a conversation in a Melbourne pub, Movember encourages its roughly 300,000 participants (about 10 percent of whom are women) to grow moustaches each November and sign up sponsors for their hirsute creations. Ladies can sponsor men or take part in other charitable activities. The group raised 80 million Australian dollars ($58,900) in 2017 and donated to more than 1,200 men’s health projects. Over the years it’s added mental health and suicide prevention to its work.</p>
        `,
        type: 'default'
      }
    },
    { 
      component: 'SectionQuote', 
      content: {
        quote: `We saw ourselves as a different type of charity. Charities hadn’t done much to engage with men.`,
        author: `Meaghan Billinski`,
        position: `Marketing Automation Director, Movember Foundation`,
        type: 'quote',
        backgroundImage: require('../../assets/images/content/p2b/page-two-b_quote@2x.jpg')
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>The foundation chose Oracle’s Marketing Cloud software, including the Eloqua tool for setting up online campaigns, to make a more concerted effort to communicate its work and goals to members on a regular basis instead of relying on word of mouth. Movember began in 2004 by raising money for the Prostate Cancer Foundation of Australia. In 2007 it started operating in the U.S. and U.K.  It now runs charity campaigns in more than 20 countries. In addition to the sponsored ‘staches, participants can raise money without by setting up golf tournaments, office parties, or bake sales.</p>
          <p>Now, Movember is bringing more rigor to the way it recruits and retains donors, including encouraging participants to make recurring gifts by getting in touch via e-mail or through notifications on its smartphone app. “For most charities it’s their bread and butter, and it’s only something we’re doing now,” says Meghan Bilinski. “We were operating more as a startup.”</p>
          <p>Movember in 2018 plans to push notifications to the 60,000 participants who’ve downloaded its app, and to start using text messaging next year. Oracle’s Eloqua marketing tools will speed up the process of localizing its pages for overseas markets. Another avenue of growth is helping Movember’s fundraising team find companies that want to participate in its programs. “In the past those fundraising teams were literally e-mailing people individually. Now we’re making smarter use of technology to automate a lot of that and they just manage the replies,” Bilinski says.</p>
        `,
        type: 'default'
      }
    },
    { 
		component: 'SectionCallToActionFullWidth',
      content: {
        title: `Transform your business with Oracle`,
        ctas: [
          { 
            image: require('../../assets/images/content/p2b/page-two-b_cta@2x.jpg'),
            copy: 'Check out our latest benefits calculator',
            url: 'https://cloud.oracle.com/datawarehouse?source=:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_IT_CT_TR_CM_UK_C18_Q24_DW&intcmp=:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_IT_CT_TR_CM_UK_C18_Q24_DW',
            buttonCopy: 'Begin calculator'
          }
        ],
        type: 'cta'
      }
    }
  ]



}

export default content;